import React from 'react'
import MenuTitle from '../../../Components/MenuTitlle/MenuTitle'
import QRCode from 'react-qr-code'
import { useParams } from 'react-router-dom'

const QrCodeToWallet = () => {
    const params=useParams()
  return (
    <div style={{width:'100vw',height:'100vh'}}>
        <MenuTitle title={"انتقال به کیف پول"} />
        <div style={{ display:'flex',justifyContent:'center', width: "100%",marginTop:'5rem' }}>
        <QRCode
            size={256}
            style={{ height: "auto", maxWidth: "320", width: "100%" }}
            value={`https://barest.ir/wallet/transfer_to/supplier/${params?.id}`}
            viewBox={`0 0 256 256`}
            fgColor="rgb(223, 0, 104)"
        />
        </div>
    </div>
  )
}

export default QrCodeToWallet